import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  DRIVER_REQUESTS_REFRESH: createSagaAction('DRIVER_REQUESTS_REFRESH'),

  CREATE_DRIVER_REQUEST: createSagaAction('CREATE_DRIVER_REQUEST'),
  UPDATE_DRIVER_REQUEST: createSagaAction('UPDATE_DRIVER_REQUEST'),
  DELETE_DRIVER_REQUEST: createSagaAction('DELETE_DRIVER_REQUEST'),

  DRIVER_REQUESTS_REPORT: createSagaAction('DRIVER_REQUESTS_REPORT'),

  UPLOAD_DRIVER_REQUEST_ATTACHMENT: createSagaAction('UPLOAD_DRIVER_REQUEST_ATTACHMENT'),
  GET_DRIVER_REQUEST_ATTACHMENTS: createSagaAction('GET_DRIVER_REQUEST_ATTACHMENTS'),
  UPDATE_DRIVER_REQUEST_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_DRIVER_REQUEST_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_DRIVER_REQUEST_ATTACHMENT: createSagaAction('DELETE_DRIVER_REQUEST_ATTACHMENT')
}

// Action Creators
export const actions = {
  driverRequestsRefresh: ({ jobId, next }) => ({
    type: constants.DRIVER_REQUESTS_REFRESH.ACTION,
    jobId,
    next
  }),

  createDriverRequest: ({ jobId, content, userId }) => ({
    type: constants.CREATE_DRIVER_REQUEST.ACTION,
    jobId,
    content,
    userId
  }),

  updateDriverRequest: ({ jobId, driverRequestId, userId, content }) => ({
    type: constants.UPDATE_DRIVER_REQUEST.ACTION,
    jobId,
    driverRequestId,
    userId,
    content
  }),

  deleteDriverRequest: ({ driverRequestId, jobId }) => ({
    type: constants.DELETE_DRIVER_REQUEST.ACTION,
    jobId,
    driverRequestId
  }),

  driverRequestReport: ({ driverRequestId, jobId }) => ({
    type: constants.DRIVER_REQUESTS_REPORT.ACTION,
    jobId,
    driverRequestId
  }),

  // Attachment actions
  uploadAttachment: ({ formData, driverRequestId }) => ({
    type: constants.UPLOAD_DRIVER_REQUEST_ATTACHMENT.ACTION,
    formData,
    driverRequestId
  }),

  getAttachments: ({ driverRequestId }) => ({
    type: constants.GET_DRIVER_REQUEST_ATTACHMENTS.ACTION,
    driverRequestId
  }),

  updateAttachmentDescription: ({ attachmentId, driverRequestId, description, userId }) => ({
    type: constants.UPDATE_DRIVER_REQUEST_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    driverRequestId,
    description,
    userId
  }),

  deleteAttachment: ({ attachmentId, driverRequestId }) => ({
    type: constants.DELETE_DRIVER_REQUEST_ATTACHMENT.ACTION,
    attachmentId,
    driverRequestId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.DRIVER_REQUESTS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.DRIVER_REQUESTS_REFRESH.SUCCESS:
      return {
        ...state,
        jobSiteDriverRequests: action.payload
      }
    case constants.DRIVER_REQUESTS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.CREATE_DRIVER_REQUEST.SUCCESS:
      return {
        ...state
      }
    case constants.UPDATE_DRIVER_REQUEST.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_DRIVER_REQUEST.SUCCESS:
      return {
        ...state
      }
    case constants.DRIVER_REQUESTS_REPORT.SUCCESS:
      return {
        ...state
      }

    case constants.UPLOAD_DRIVER_REQUEST_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_DRIVER_REQUEST_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_DRIVER_REQUEST_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_DRIVER_REQUEST_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobDriverRequestAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_DRIVER_REQUEST_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_DRIVER_REQUEST_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_DRIVER_REQUEST_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteDriverRequestActions.js